'use client';

import React from 'react';

import TopicPageSkeleton from '@/components/storyblok/TopicPage/TopicPageSkeleton/TopicPageSkeleton';

const Loading = () => {
  return <TopicPageSkeleton />;
};

export default Loading;
